export const REFERRAL_LINK_BASE_URL = 'https://diagnocat.ru/';

// TODO: set the published referral terms URL; the "Referral terms" link stays hidden while it is empty.
export const REFERRAL_TERMS_URL = '';

export const COPIED_STATE_DURATION_MS = 2400;

// The QR spec's white border; scanners struggle with less, especially on a dark page.
export const QR_QUIET_ZONE_MODULES = 4;

export const INLINE_QR_SIZE = 112;
export const MODAL_QR_SIZE = 320;
export const MOBILE_QR_SIZE = 248;

// 1200 = 80 padding + 1040 code (its 4-module quiet zone included) + 80 padding; the link is printed in the bottom band.
export const REFERRAL_QR_PNG = {
  width: 1200,
  height: 1360,
  padding: 80,
  qrSize: 1040,
  textCenterY: 1250,
  fontSize: 40,
  fontFamily: 'Arial, Helvetica, sans-serif',
  fileName: 'diagnocat-referral-qr.png',
} as const;
